"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var close_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/actions/close.svg"));

var tip_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/navigation/tip.svg"));

var Avatar_1 = __importDefault(require("../Avatar/Avatar"));

var withStyles_1 = require("../decorators/withStyles");

var fillIcon_1 = require("../helpers/fillIcon");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Text_1 = __importDefault(require("../Text/Text"));

var Contact_styles_1 = require("./Contact.styles");

var Contact = function Contact(props) {
  var title = props.title,
      description = props.description,
      avatar = props.avatar,
      icon = props.icon,
      _a = props.status,
      status = _a === void 0 ? 'ok' : _a,
      classes = props.classes,
      theme = props.theme,
      _b = props.testIds,
      testIds = _b === void 0 ? {} : _b;
  var colorIconContrast = theme.colorIconContrast.normal;
  var whiteClose = fillIcon_1.fillIcon(close_svg_1.default, {
    fill: colorIconContrast
  });
  var whiteQuestion = fillIcon_1.fillIcon(tip_svg_1.default, {
    fill: colorIconContrast
  });
  var statusNotApproved = status === 'not_approved';
  var statusCancel = status === 'cancel';
  var statusOk = status === 'ok';
  return react_1.default.createElement("div", {
    "data-test-id": testIds.contact,
    className: classes.contact
  }, react_1.default.createElement("div", {
    className: classes.contactAvatar
  }, react_1.default.createElement(Avatar_1.default, {
    small: true,
    image: avatar,
    icon: !avatar && icon
  }), !statusOk && react_1.default.createElement("div", {
    className: classes.overlay
  }, statusNotApproved && react_1.default.createElement(Icon_1.default, {
    icon: whiteQuestion
  }), statusCancel && react_1.default.createElement(Icon_1.default, {
    icon: whiteClose
  }))), react_1.default.createElement("div", {
    className: classes.contactDetails
  }, react_1.default.createElement("div", null, react_1.default.createElement(Text_1.default, {
    testId: testIds.title,
    secondary: !statusOk
  }, title)), description && react_1.default.createElement("div", null, react_1.default.createElement(Text_1.default, {
    testId: testIds.description,
    mode: "small",
    secondary: true
  }, description))));
};

exports.default = withStyles_1.withStyles(Contact_styles_1.styles)(Contact);